import { render, staticRenderFns } from "./ReceiptQuery.vue?vue&type=template&id=a77dc6b6"
import script from "./ReceiptQuery.vue?vue&type=script&lang=js"
export * from "./ReceiptQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports